import React, { useCallback, useEffect, useRef } from "react";
import { useAtom } from "jotai";
import { onlinesAtom } from "../jotai/atoms";
import { useSendAnalyticsEvent } from "./events";
import useInterval from "../utils/useInterval";

export default function useAnalytics() {
  const sendAnalyticsEvent = useSendAnalyticsEvent();
  const [onlines] = useAtom(onlinesAtom);
  const spaceLoadedRef = useRef(false);

  // Wait to send the space loaded event until onlines have loaded so
  // we can get the correct number of users
  useEffect(() => {
    if (onlines.size > 0 && !spaceLoadedRef.current) {
      spaceLoadedRef.current = true;
      sendAnalyticsEvent({ name: "spaceLoaded" });
    }
  }, [onlines, sendAnalyticsEvent]);

  const activePing = useCallback(() => {
    if (spaceLoadedRef.current) {
      sendAnalyticsEvent({ name: "activeSpacePing" });
    }
  }, [sendAnalyticsEvent]);
  useInterval(activePing, 60 * 1000);

  return <></>;
}
